$(document).ready(function() {

    $('[data-toggle="tooltip"]').each(function(){
        var $this= $(this);
        $this.tooltip({
            html: true, // not recommended open for XSS attacks but required for old code.
            trigger: ($this.data('hover') ? $this.data('hover') : 'hover focus')
        });
    });

});
